const registeredUnitsData = {
    accommodation: [
        {
            name: "ISHAAN SAROVAR PORTICO",
            regNo: "JHT/ACD/263/2411010003",
            mobile: "9650500126",
            email: "ishaan.sarovardeoghar@gmail.com",
            address: "833, CASTAIRS TOWN, DEOGHAR"
        },
        {
            name: "Shree Durga Heights",
            regNo: "JHT/ACD/261/2511040031",
            mobile: "7070464008",
            email: "sdhotels1246@gmail.com",
            address: "Plot No.1246, Telgaria More , Chas, Bokaro, Jharkhand, 827013"
        },
        {
            name: "HOTEL SABHEKAR",
            regNo: "JHT/ACD/270/2502030004",
            mobile: "7999996275",
            email: "hotelsabhekar@gmail.com",
            address: "TOWER CHOWK, SISAI ROAD, GUMLA, JHARKHAND"
        },
        {
            name: "SONOTEL HOTELS AND RESORTS PRIVATE LIMITED",
            regNo: "JHT/ACD/264/2502020004",
            mobile: "9234423832",
            email: "accounts@sonotelhotels.com",
            address: "5th Floor, Ozone Galleria, Saraidhela, Dhanbad - 828127"
        },
        {
            name: "LARANG",
            regNo: "JHT/ACD/280/2505030014",
            mobile: "9501251419",
            email: "dkispotta@gmail.com",
            address: "LANE NO.3, GAURI PATH DALADILI ROAD, SIMALIYA, NEAR ANKUR NURSERY, RANCHI - 834005"
        },
        {
            name: "VINAIKA ECO RESORT",
            regNo: "JHT/ACD/280/2503030009",
            mobile: "8877772200",
            email: "vinay12123@gmail.com",
            address: "MADHKAMA, SADMA BAZAR, ORMANJHI RANCHI - 835219"
        },
        {
            name: "IRIS VILLAGE",
            regNo: "JHT/ACD/272/2505030013",
            mobile: "9332465557",
            email: "irisvillageresort@gmail.com",
            address: "Village Talberia, Ladhna, Mihijam, Jharkhand - 815351"
        },
        {
            name: "THE GRAND MIRAGE DHANBAD",
            regNo: "JHT/ACD/264/2506030015",
            mobile: "9538085372",
            email: "info.dhanbad@radissonindividuals.com",
            address: "Dhansar Chowk, Dhanbad, Jharkhand - 828106"
        },
        {
            name: "BHALOTIA RESIDENCY AND RESORTS PVT. LTD.",
            regNo: "JHT/ACD/266/2507030020",
            mobile: "9934255555",
            email: "krishna.bhalotia@gmail.com",
            address: "Holding No.2, Contractors Area, Bistupur, Jamshedpur - 831001"
        },
        {
            name: "RADISSON HOTEL JAMSHEDPUR",
            regNo: "JHT/ACD/266/2508030029",
            mobile: "7004652473",
            email: "nitin@citycentretatanagar.co.in",
            address: "Plot No.952, (P), 966 (P) & 973 (P), Khata No. - 02, Ward No. - 4, Makdampur Area, Jugsalai, Jamshedpur - 831001"
        },
        {
            name: "The Shyama Inn",
            regNo: "JHT/ACD/269/2509030032",
            mobile: "8936873784",
            email: "kritibhusan93@gmail.com",
            address: "Plot No.-516, Jamabandi No.14/2, Jamua, Poreyahat, Godda, Jharkhand - 814133"
        }
    ],

    aso: [
        {
            name: "Adventure Travellers Academy",
            regNo: "JHT/ASO/268/2409010004",
            mobile: "7903795687",
            email: "trustadventure@yahoo.com",
            address: "Saluja Complex, behind Kedia Sweets, Court Road, Giridih, Jharkhand - 815301"
        },
        {
            name: "THE ADVENTURE BAY",
            regNo: "JHT/ASO/271/2409010005",
            mobile: "9955390090",
            email: "the_adventure_bay@yahoo.com",
            address: "C/o Tushar Nag 'Shangrila ', opposite Housing board colony, Dipugarha, Hazaribag 825301"
        },
        {
            name: "ADVENTURE FRONTIERS",
            regNo: "JHT/ASO/266/2509020009",
            mobile: "7763807239",
            email: "rajesh.nagarkoti75@gmail.com",
            address: "104 Road Number 5,Circuit House Area Sonari"
        }
    ],

    boat: [
        {
            name: "PRAMOD KUMAR",
            regNo: "JHT/BTO/268/2505020005",
            mobile: "9431144000",
            email: "pramodkumar66@gmail.com",
            address: "Court Road, barganda, Giridih - 815301"
        },
        {
            name: "TASIR ANWAR",
            regNo: "JHT/BTO/268/2510020009",
            mobile: "9074684148",
            email: "tasir244@gmail.com",
            address: "VILL-BHOJADAHA PO-MOTILEDHA, Bengabad, Giridih, Jharkhand - 815302"
        }
    ],

    tourOperators: [
        {
            name: "GHOOMKEDEKHO TRIPS PLANNER PVT LTD",
            regNo: "JHT/TTT/280/240900008",
            mobile: "6202549767",
            email: "ranchi.ghoomkedekho@gmail.com",
            address: "1st FLOOR, SHOP NO. 9, A. R. K. MARKET, BESIDE LALPUR THANA, Lalpur, Ranchi - 834001"
        },
        {
            name: "LATEHAR TOURISM",
            regNo: "JHT/TTT/275/240900009",
            mobile: "9470938399",
            email: "latehartourism@gmail.com",
            address: "RAJHAR STATION, Latehar, Jharkhand"
        },
        {
            name: "JAI TOURS AND TRAVELS PVT LTD",
            regNo: "JHT/TTT/280/2409000010",
            mobile: "9470333588",
            email: "ajit@jaitravels.co.in",
            address: "604, 6TH FLOOR, MODI HEIGHTS PHASE II, Ratu Road, Ranchi- 834001"
        },
        {
            name: "Destination Unlimited Tour and Travels",
            regNo: "JHT/TTT/266/2409000011",
            mobile: "7004602064",
            email: "hotelcontracts.du@gmail.com",
            address: "Om Plaza, 3rd floor, TF-5, Aambagan, Sakchi, Jamshedpur - 831001"
        },
        {
            name: "SUHANA TOURS & TRAVELLERS",
            regNo: "JHT/TTT/280/2409010002",
            mobile: "9431171394",
            email: "sahay.amar30@gmail.com",
            address: "C /4 GURU NANAK MARKET, GURUDWARA, Station Road, Ranchi - 834001"
        },
        {
            name: "Betla tour & travels",
            regNo: "JHT/TTT/275/2501020004",
            mobile: "9955527371",
            email: "raslamansari91@gmail.com",
            address: "Betla national park, Latehar, Jharkhand"
        },
        {
            name: "TRAVEL STAR HOLIDAYS",
            regNo: "JHT/TTT/280/2501020005",
            mobile: "7870652340",
            email: "travelstarranchi@gmail.com",
            address: "1st floor, Capitol Hill, Main Road, Ranchi"
        },
        {
            name: "Experience Jharkhand",
            regNo: "JHT/TTT/275/2501020006",
            mobile: "7209924212",
            email: "reach.sarfarazahmed@gmail.com",
            address: "59/3, Main Bazar, Near Electric Office,Barwadih, Latehar - 822111"
        },
        {
            name: "GO FLY TRIP",
            regNo: "JHT/TTT/275/2503030003",
            mobile: "8082060324",
            email: "helpgoflytrip@gmail.com",
            address: "Near Madina Masjid, Murup Road Chope, Latehar, Jharkhand - 829206"
        },
        {
            name: "SKY LINE SERVICES",
            regNo: "JHT/TTT/280/2505030006",
            mobile: "9431105084",
            email: "skylineservices45@gmail.com",
            address: "Qr.No.-B-356, SECTOR-3, H.E.C, Dhurwa, Ranchi"
        },
        {
            name: "Plan My Escape",
            regNo: "JHT/TTT/280/2503030004",
            mobile: "9102025523",
            email: "sales@planmyescape.in",
            address: "Gas Godown, 109, Pearl Crest, Pundag Road, Pundag, Ranchi - 834002"
        },
        {
            name: "SUDIPI HOLIDAYS",
            regNo: "JHT/TTT/264/2504030005",
            mobile: "9835564746",
            email: "dinanathrs@yahoo.com",
            address: "SUDIPI HOLIDAYS , NEAR-USHA TALKIES, THANA ROAD, Jharia, Dhanbad"
        },
        {
            name: "MOBILE PLAZA TOUR & TRAVELS",
            regNo: "JHT/TTT/280/2505030008",
            mobile: "7739089052",
            email: "bkarmakarmptt@gmail.com",
            address: "IRGU ROAD. KUMHARTOLI, P O. GPO, PS SUKHDEB NAGAR, WORD NO 30, Ranchi - 834001"
        },
        {
            name: "OM SHANTI TOUR AND TRAVELS",
            regNo: "JHT/TTT/284/2507030016",
            mobile: "9431183838",
            email: "omshantitata@gmail.com",
            address: "OM SHANTI TOWER SHOP NO 07 KAGAL NAGAR MARKET, Jamshedpur"
        },
        {
            name: "GOTRIPWALA HOLIDAYS",
            regNo: "JHT/TTT/280/2505030011",
            mobile: "9973848309",
            email: "gotripwala@gmail.com",
            address: "RAJA COMPLEX, 1ST FLOOR, BARIATU, Ranchi"
        },
        {
            name: "Farq Corporation",
            regNo: "JHT/TTT/280/2506030015",
            mobile: "9135269474",
            email: "exploretusu@gmail.com",
            address: "Farooqui Street, Imli Chowk, Harmu, Ranchi - 834002"
        },
        {
            name: "BANKIM TRAVEL AGENCY",
            regNo: "JHT/TTT/280/2509030021",
            mobile: "9204016825",
            email: "sr11888@gmail.com",
            address: "BANKIM TRAVEL AGENCY C/O SANJAY KUMAR SINGH,CHAPU-TOLI CHOWK, NEAR ITI-INSTITUTE, Pundag, Ranchi - 834004"
        },
        {
            name: "NEW MITTAL TRAVELS",
            regNo: "JHT/TTT/276/2509030058",
            mobile: "9122221193",
            email: "mtloh5443@gmail.com",
            address: "AGRAWAL MUHALLA, MAHABIR CHOWK, Lohardaga"
        },
        {
            name: "J.Enterprises",
            regNo: "JHT/TTT/273/2512040023",
            mobile: "9430333612",
            email: "mk.jaiswal88@yahoo.com",
            address: "Main Road, Khunti"
        },
        {
            name: "KALYANA AVIATION & SECURITY SERVICES PVT LTD",
            regNo: "JHT/TTT/280/2508030018",
            mobile: "6206402556",
            email: "kalyana.aviation@gmail.com",
            address: "AIRPORT ROAD, Hinoo, Ranchi - 834002"
        },
        {
            name: "A G TOURS PRIVATE LIMITED",
            regNo: "JHT/TTT/266/2511040021",
            mobile: "9810412295",
            email: "agtoursindia@gmail.com",
            address: "Floor No.: 3rd floor, Building No./Flat No.: 101 Alison Apartment Thakur Bari Road, Sakchi, Jamshedpur, Jharkhand - 831001"
        },
        {
            name: "AIRSTARIX TOURS AND TRAVELS PRIVATE LIMITED",
            regNo: "JHT/TTT/266/2511040020",
            mobile: "7008501196",
            email: "jjco.hrd@gmail.com",
            address: "1183, Dutta Para, Near Almari Factory, Shiv mandir Haludbani, Tatanagar, Parsudih, Jamshedpur, Jharkhand - 831002"
        },
        {
            name: "Durga Enterprises",
            regNo: "JHT/TTT/274/2512040025",
            mobile: "7856022259",
            email: "durgaenterprises2325@gmail.com",
            address: "Manjhlitand Road, Domchanch, Koderma - 824507"
        },
        {
            name: "SADHU ENTERPRISES",
            regNo: "JHT/TTT/264/2601040028",
            mobile: "8709162191",
            email: "sadhuenterprises1985@gmail.com",
            address: "VILL-VILLAGE ROAD, P.O & P.S- GOVINDUR, Dhanbad - 828109"
        },
        {
            name: "Kalicharan Sahu",
            regNo: "JHT/TTT/282/2601040033",
            mobile: "9234258551",
            email: "kalicharansahu1983@gmail.com",
            address: "7, WARD 7, SERAIKELA, SERAIKELA, SERAIKELA KHARSAWAN, Seraikela- Kharsawan, Jharkhand - 833219"
        },
        {
            name: "sankalp yatra",
            regNo: "JHT/TTT/281/2601040034",
            mobile: "7856998461",
            email: "sankalpyatra11@email.com",
            address: "MOTI PAHARI, Borio"
        },
        {
            name: "M/S GUPTA TRADERS",
            regNo: "JHT/TTT/267/2601040041",
            mobile: "8434540900",
            email: "sudhirkr84345@gmail.com",
            address: "WARD NO.3, BHAWNATHPUR, Garhwa, Jharkhand, 822112"
        }
    ],

    guides: [
        {
            name: "AMIT ORAON",
            regNo: "JHT/TRG/270/2505030004",
            mobile: "7759827248",
            email: "amitoraon1234@gmail.com",
            address: "Vill- Lanju Navatoli, PO- Khora, PS- Gumla, Jharkhand- 835207"
        },
        {
            name: "ARVIND KUMAR MAHTO",
            regNo: "JHT/TRG/279/2505030005",
            mobile: "9546266647",
            email: "mahtoarvindkumar59@gmail.com",
            address: "AT ARA BASTI PO SARUBERA PS Mandu"
        },
        {
            name: "Kunal Jha",
            regNo: "JHT/TRG/263/2507030006",
            mobile: "9971501989",
            email: "ikunaljha@gmail.com",
            address: "H. No. 8525/06, Near Hotel Hariyali, Pokhnatilha, Pt. B.N.Jha Path - 814112"
        },
        {
            name: "AMBIKA BHARDWAJ",
            regNo: "JHT/TRG/263/2507030007",
            mobile: "9771512235",
            email: "bharwas.ambika@gmail.com",
            address: "JHOUSAGARI REFUJEE COLONY, DEOGHAR, JHARKHAND- 814112"
        },
        {
            name: "Surendra Bhuiyan",
            regNo: "JHT/TRG/276/2507030008",
            mobile: "6205575912",
            email: "surendraramkundgara@gmail.com",
            address: "Village-Kundgara, Post-Barkichanpi, Lohardaga"
        }
    ],

    photographers: [
        {
            name: "Ankush Kumar Kasera",
            regNo: "JHT/PTP/280/2409010001",
            mobile: "7620806044",
            email: "ankushkr2020@gmail.com",
            address: "D2, Urmila Roy Complex, Circular Road, Lalpur, 834001"
        },
        {
            name: "ANKIT SAHU",
            regNo: "JHT/PTP/270/2504020007",
            mobile: "9955428618",
            email: "workingankitt@gmail.com",
            address: "GSHASTRI NAGAR, POST GUMLA PS GUMLA DISTRICT GUMLA"
        },
        {
            name: "Dhiraj Kumar",
            regNo: "JHT/PTP/268/2502020002",
            mobile: "7368004188",
            email: "dhirajkumarraju070@gmail.com",
            address: "Village - Guro, Post - Senadoni, District- Giridih, Jharkhand, India (pin code - 815316)"
        },
        {
            name: "MD DILSHAD",
            regNo: "JHT/PTP/270/2504020008",
            mobile: "8294219983",
            email: "mdd23050@gmail.com",
            address: "Village - Goya, Post - Belagara, PS - Ghaghra, Gumla, Jharkhand - 835208"
        },
        {
            name: "Abhishek Kumar",
            regNo: "JHT/PTP/270/2507020010",
            mobile: "7488404933",
            email: "muskuraiyeaapgumlamehai@gmail.com",
            address: "Ward No-20, SARNA TOLI Gumla, Gumla, Jharkhand 835207"
        },
        {
            name: "Tapan Kumar Goswami",
            regNo: "JHT/PTP/265/2602030043",
            mobile: "7763821117",
            email: "kumartapan459@gmail.com",
            address: "Vill - Lakhikundi, Baghmara, P.O - Asansol, P.S - Dumka, Dist - Dumka, 814119"
        },
        {
            name: "Kuldeep Yadav",
            regNo: "JHT/PTP/276/2507020016",
            mobile: "7004947627",
            email: "yadavkuldeep41895@gmail.com",
            address: "VILLAGE PESHRAR, POST PESHRAR,DIST-LOHARDAGA,JHARKHAND,835302"
        },
        {
            name: "RITIK PATWA",
            regNo: "JHT/PTP/264/2507020019",
            mobile: "9234008506",
            email: "ritikpatwa98357@gmail.com",
            address: "Katras Bazar Rawani Tola, Near Shitla Mandir , Katras Bazar , Pin 828114"
        },
        {
            name: "SAROJ KUMAR",
            regNo: "JHT/PTP/276/2507020022",
            mobile: "9304264556",
            email: "skumar12131415@gmail.com",
            address: "OLD SHUKRA BAZAR, NEAR AJAY PARK LOHARDAGA,835302"
        },
        {
            name: "Ajay Kumar Gupta",
            regNo: "JHT/PTP/276/2507020029",
            mobile: "9835521053",
            email: "ajaykutmu@gmail.com",
            address: "Old Sukr Bazar,Lohardaga,DIstt Lohardaga"
        },
        {
            name: "Talmiz lucky",
            regNo: "JHT/PTP/267/2507020015",
            mobile: "6200775115",
            email: "talmizvlogs@gmail.com",
            address: "village- patsa post-sangrahe kala, Garhwa"
        },
        {
            name: "MADAN KUMAR",
            regNo: "JHT/PTP/276/2507020025",
            mobile: "7004947627",
            email: "madankumar25011983@gmail.com",
            address: "Hatia Garden, Lohardaga"
        },
        {
            name: "PAWAN KUMAR",
            regNo: "JHT/PTP/276/2507020026",
            mobile: "9835549295",
            email: "pawan.harshit73@gmail.com",
            address: "Hatia Garden, Lohardaga"
        },
        {
            name: "Gaurav Kumar",
            regNo: "JHT/PTP/276/2507020028",
            mobile: "8789012791",
            email: "gaurav424121@gmail.com",
            address: "Village-Alaudi,Post Heswe,Block Senha,DIst Lohardaga"
        },
        {
            name: "Tanveer Alam",
            regNo: "JHT/PTP/273/2508020033",
            mobile: "7667564115",
            email: "mdtanveeralam43603@gmail.com",
            address: "Karra Road, Khunti"
        },
        {
            name: "RANJIT KUMAR",
            regNo: "JHT/PTP/264/2512030032",
            mobile: "9905112301",
            email: "ranjitjaiswal77@gmail.com",
            address: "C.K. DIGITAL STUDIO, NEAR PRABHATAM MALL , POST OFFICE - ISM , DHAIYA, DHANBAD"
        },
        {
            name: "Dhananjay Kumar",
            regNo: "JHT/PTP/261/2512030034",
            mobile: "8789897960",
            email: "dhananjaykumar7618@gmail.com",
            address: "Nawadih, Nawadih, PO: Nawadih, DIST: Bokaro,Jharkhand - 829144"
        },
        {
            name: "Ramchandra Das",
            regNo: "JHT/PTP/268/2512030036",
            mobile: "9798186149",
            email: "ramchandradas256@gmail.com",
            address: "Vill- Bhorandiha, Post - Budhiyadih, P.S. - Giridih, Jharkhand 815302"
        },
        {
            name: "RAJ KISHOR KUMAR",
            regNo: "JHT/PTP/261/2512030035",
            mobile: "9798973550",
            email: "ekphilim@gmail.com",
            address: "BQno.1335 stree 7 Sector 8/A Post office-Sector 9 Bokaro Steel City Jharkhand 827009"
        },
        {
            name: "SUSHIL KUMAR",
            regNo: "JHT/PTP/274/2601030037",
            mobile: "7739745868",
            email: "sk03730@gmail.com",
            address: "Pandaw Bhawan, Sahana road , Near Raja talab, Koderma 825410"
        },
        {
            name: "ASISH SUN MARDI",
            regNo: "JHT/PTP/282/2601030038",
            mobile: "9030763042",
            email: "adan.asish@gmail.com",
            address: "Vill- Chota Bana, PO- Dholadih, PS- Rajnagar, Panchayat - Katanga"
        },
        {
            name: "ARIF ANSARI",
            regNo: "JHT/PTP/272/2602030042",
            mobile: "9065108595",
            email: "mdarifbhai493@gmail.com",
            address: "DHABKO PO- RANITAND, VTC: NARAYANPUR , PO- NARAYANPUR, SUB DISTRICT: NARAYANPUR, DISTRICT- JAMTARA, STATE JHARKHAND, PIN- 815352"
        }
    ]
};

export default registeredUnitsData;